import util from 'util/common'

const state = {
  lecturer_no: '',
  name: '',
  name_kana: '',
  published: '',
  lecturer_name: '',
  lecturer_name_kana: '',
  birthday: '',
  birthday_publish: '',
  email: '',
  email_publish: '',
  zipcode: '',
  prefecture: '',
  city: '',
  address1: '',
  address2: '',
  tel: '',
  homepage: '',
  homepage_publish: '',
  facebook: '',
  facebook_publish: '',
  line: '',
  line_publish: '',
  instagram: '',
  instagram_publish: '',
  blog: '',
  blog_publish: '',
  active_area1: '',
  active_area2: '',
  introduction: '',
  qualification: '',
  trigger: '',
  good_things: '',
  work_image1: '',
  work_image2: '',
  lecturer_status: '',
  lecturer_statuses: [],
  member_status: '',
  profile_image: '',

  bank: {
    name: '',
    branch_store: '',
    store_number: '',
    deposit_type: '',
    account: '',
    holder_name: ''
  },

  work_images: []
}

const mutations = {
  updateLecturerLecturerNo (state, value) {
    state.lecturer_no = value
  },
  updateLecturerName (state, value) {
    state.name = value
  },
  updateLecturerNameKana (state, value) {
    state.name_kana = value
  },
  updateLecturerPublished (state, value) {
    state.published = value
  },
  updateLecturerLecturerName (state, value) {
    state.lecturer_name = value
  },
  updateLecturerBirthday (state, value) {
    state.birthday = value
  },
  updateLecturerBirthdayPublish (state, value) {
    state.birthday_publish = value
  },
  updateLecturerEmail (state, value) {
    state.email = value
  },
  updateLecturerEmailPublish (state, value) {
    state.email_publish = value
  },
  updateLecturerZipcode (state, value) {
    state.zipcode = value
  },
  updateLecturerPrefecture (state, value) {
    state.prefecture = value
  },
  updateLecturerCity (state, value) {
    state.city = value
  },
  updateLecturerAddress1 (state, value) {
    state.address1 = value
  },
  updateLecturerAddress2 (state, value) {
    state.address2 = value
  },
  updateLecturerTel (state, value) {
    state.tel = value
  },
  updateLecturerHomepage (state, value) {
    state.homepage = value
  },
  updateLecturerHomepagePublish (state, value) {
    state.homepage_publish = value
  },
  updateLecturerFacebook (state, value) {
    state.facebook = value
  },
  updateLecturerFacebookPublish (state, value) {
    state.facebook_publish = value
  },
  updateLecturerLine (state, value) {
    state.line = value
  },
  updateLecturerLinePublish (state, value) {
    state.line_publish = value
  },
  updateLecturerInstagram (state, value) {
    state.instagram = value
  },
  updateLecturerInstagramPublish (state, value) {
    state.instagram_publish = value
  },
  updateLecturerBlog (state, value) {
    state.blog = value
  },
  updateLecturerBlogPublish (state, value) {
    state.blog_publish = value
  },
  updateLecturerActiveArea1 (state, value) {
    state.active_area1 = value
  },
  updateLecturerActiveArea2 (state, value) {
    state.active_area2 = value
  },
  updateLecturerIntroduction (state, value) {
    state.introduction = value
  },
  updateLecturerQualification (state, value) {
    state.qualification = value
  },
  updateLecturerTrigger (state, value) {
    state.trigger = value
  },
  updateLecturerGoodThings (state, value) {
    state.good_things = value
  },
  updateLecturerWorkImages (state, value) {
    if (util.isArray(value)) {
      state.work_images = value
    } else {
      state.work_images[value.index] = value.data
    }
  },
  updateLecturerLecturerStatus (state, value) {
    state.lecturer_status = value
  },
  updateLecturerLecturerStatuses (state, value) {
    state.lecturer_statuses = value
  },
  updateLecturerMemberStatus (state, value) {
    state.member_status = value
  },
  updateLecturerProfileImage (state, value) {
    state.profile_image = value
  },

  updateLecturerBank (state, value) {
    mutations.updateLecturerBankName(state, value.name)
    mutations.updateLecturerBankBranchStore(state, value.branch_store)
    mutations.updateLecturerBankStoreNumber(state, value.store_number)
    mutations.updateLecturerBankDepositType(state, value.deposit_type)
    mutations.updateLecturerBankAccount(state, value.account)
    mutations.updateLecturerBankHolderName(state, value.holder_name)
  },
  updateLecturerBankName (state, value) { state.bank.name = value },
  updateLecturerBankBranchStore (state, value) { state.bank.branch_store = value },
  updateLecturerBankStoreNumber (state, value) { state.bank.store_number = value },
  updateLecturerBankDepositType (state, value) { state.bank.deposit_type = value },
  updateLecturerBankAccount (state, value) { state.bank.account = value },
  updateLecturerBankHolderName (state, value) { state.bank.holder_name = value },

  updateLecturerLecturerNameKana (state, value) { state.lecturer_name_kana = value },

  updateLecturerForm (state, value) {
    mutations.updateLecturerLecturerNo(state, value.lecturer_no)
    mutations.updateLecturerName(state, value.name)
    mutations.updateLecturerNameKana(state, value.name_kana)
    mutations.updateLecturerPublished(state, value.published)
    mutations.updateLecturerLecturerName(state, value.lecturer_name)
    mutations.updateLecturerLecturerNameKana(state, value.lecturer_name_kana)
    mutations.updateLecturerBirthday(state, value.birthday)
    mutations.updateLecturerBirthdayPublish(state, value.birthday_publish)
    mutations.updateLecturerEmail(state, value.email)
    mutations.updateLecturerEmailPublish(state, value.email_publish)
    mutations.updateLecturerZipcode(state, value.zipcode)
    mutations.updateLecturerPrefecture(state, value.prefecture)
    mutations.updateLecturerCity(state, value.city)
    mutations.updateLecturerAddress1(state, value.address1)
    mutations.updateLecturerAddress2(state, value.address2)
    mutations.updateLecturerTel(state, value.tel)
    mutations.updateLecturerHomepage(state, value.homepage)
    mutations.updateLecturerHomepagePublish(state, value.homepage_publish)
    mutations.updateLecturerFacebook(state, value.facebook)
    mutations.updateLecturerFacebookPublish(state, value.facebook_publish)
    mutations.updateLecturerLine(state, value.line)
    mutations.updateLecturerLinePublish(state, value.line_publish)
    mutations.updateLecturerInstagram(state, value.instagram)
    mutations.updateLecturerInstagramPublish(state, value.instagram_publish)
    mutations.updateLecturerBlog(state, value.blog)
    mutations.updateLecturerBlogPublish(state, value.blog_publish)
    mutations.updateLecturerActiveArea1(state, value.active_area1)
    mutations.updateLecturerActiveArea2(state, value.active_area2)
    mutations.updateLecturerIntroduction(state, value.introduction)
    mutations.updateLecturerQualification(state, value.qualification)
    mutations.updateLecturerTrigger(state, value.trigger)
    mutations.updateLecturerGoodThings(state, value.good_things)
    mutations.updateLecturerWorkImages(state, value.work_images || [value.work_image1, value.work_image2].filter(i => i !== ''))
    mutations.updateLecturerLecturerStatus(state, value.lecturer_status)
    mutations.updateLecturerLecturerStatuses(state, value.lecturer_statuses)
    mutations.updateLecturerMemberStatus(state, value.member_status)
    mutations.updateLecturerProfileImage(state, value.profile_image)
    mutations.updateLecturerBank(state, value.bank)
  },
  clearLecturerForm (state) {
    Object.keys(state).forEach(k => { state[k] = '' })
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/lecturer_form/store.js